import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useInputMask } from "@Shared/@Composables/inputs/useInputMaks";
import { GLOBAL_APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import AddressAutocompleteField from "@Shared/components/form-elements/fields/address-autocomplete-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import AddressLayout from "@Shared/components/layouts/general/address-layout.vue";
import { computed, defineComponent, onMounted, ref, watchEffect, nextTick } from "@vue/composition-api";
import { uniqueId } from "lodash";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "AddressFieldGroup",
  components: {
    AddressAutocompleteField,
    AddressLayout,
    TextField,
    SelectField
  },
  props: {
    line1: {
      type: String,
      default: ""
    },
    line2: {
      type: String,
      default: ""
    },
    unitNumber: {
      type: String,
      default: ""
    },
    streetNumber: {
      type: String,
      default: ""
    },
    streetName: {
      type: String,
      default: ""
    },
    streetDirection: {
      type: String,
      default: ""
    },
    streetType: {
      type: String,
      default: ""
    },
    province: {
      type: String,
      default: ""
    },
    city: {
      type: String,
      default: ""
    },
    postalCode: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: () => ({})
    },
    showAutoCompleteLabel: {
      type: Boolean,
      default: false
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const line1Model = computed({
      get() {
        return props.line1;
      },
      set(value) {
        emit("update:line1", value);
      }
    });
    const line2Model = computed({
      get() {
        return props.line2;
      },
      set(value) {
        emit("update:line2", value);
      }
    });
    const unitNumberModel = computed({
      get() {
        return props.unitNumber;
      },
      set(value) {
        emit("update:unitNumber", value);
      }
    });
    const streetNumberModel = computed({
      get() {
        return props.streetNumber;
      },
      set(value) {
        emit("update:streetNumber", value.toString());
      }
    });
    const streetNameModel = computed({
      get() {
        return props.streetName;
      },
      set(value) {
        emit("update:streetName", value);
      }
    });
    const streetDirectionModel = computed({
      get() {
        return props.streetDirection;
      },
      set(value) {
        emit("update:streetDirection", value);
      }
    });
    const streetTypeModel = computed({
      get() {
        return props.streetType;
      },
      set(value) {
        emit("update:streetType", value);
      }
    });
    const provinceModel = computed({
      get() {
        return props.province;
      },
      set(value) {
        emit("update:province", value);
      }
    });
    const cityModel = computed({
      get() {
        return props.city;
      },
      set(value) {
        emit("update:city", value);
      }
    });
    const postalCodeModel = computed({
      get() {
        return props.postalCode;
      },
      set(value) {
        var _context;
        emit("update:postalCode", _trimInstanceProperty(_context = _replaceAllInstanceProperty(value).call(value, "_", "")).call(_context));
      }
    });
    const typeManualAddress = ref(false);
    const showAddressFields = computed(() => {
      return !!line1Model.value || !!line2Model.value || !!unitNumberModel.value || !!provinceModel.value || !!cityModel.value || !!postalCodeModel.value;
    });
    onMounted(() => {
      nextTick(() => {
        var _props$validator, _props$validator$city;
        if ((_props$validator = props.validator) != null && (_props$validator$city = _props$validator.city) != null && _props$validator$city.required && props.validator.$invalid && props.validator.$dirty) {
          typeManualAddress.value = true;
        }
      });
    });
    watchEffect(() => {
      if (showAddressFields.value) typeManualAddress.value = true;
    });
    const handleAutocomplete = address => {
      line1Model.value = address.line1;
      line2Model.value = address.line2;
      unitNumberModel.value = address["unit-number"];
      provinceModel.value = address.province;
      cityModel.value = address.city;
      postalCodeModel.value = address["postal-code"];
      streetDirectionModel.value = address["street-direction"];
      streetNameModel.value = address["street-name"];
      streetNumberModel.value = address["street-number"];
      streetTypeModel.value = address["street-type"];
    };
    const validatorFields = computed(() => {
      var _props$validator$line, _props$validator2, _props$validator$line2, _props$validator3, _props$validator$unit, _props$validator4, _props$validator$prov, _props$validator5, _props$validator$city2, _props$validator6, _props$validator$post, _props$validator7, _props$validator$stre, _props$validator8, _props$validator$stre2, _props$validator9;
      return {
        line1: (_props$validator$line = (_props$validator2 = props.validator) == null ? void 0 : _props$validator2.line1) != null ? _props$validator$line : null,
        line2: (_props$validator$line2 = (_props$validator3 = props.validator) == null ? void 0 : _props$validator3.line2) != null ? _props$validator$line2 : null,
        unitNumber: (_props$validator$unit = (_props$validator4 = props.validator) == null ? void 0 : _props$validator4.unitNumber) != null ? _props$validator$unit : null,
        province: (_props$validator$prov = (_props$validator5 = props.validator) == null ? void 0 : _props$validator5.province) != null ? _props$validator$prov : null,
        city: (_props$validator$city2 = (_props$validator6 = props.validator) == null ? void 0 : _props$validator6.city) != null ? _props$validator$city2 : null,
        postalCode: (_props$validator$post = (_props$validator7 = props.validator) == null ? void 0 : _props$validator7["postal-code"]) != null ? _props$validator$post : null,
        streetName: (_props$validator$stre = (_props$validator8 = props.validator) == null ? void 0 : _props$validator8["street-name"]) != null ? _props$validator$stre : null,
        streetNumber: (_props$validator$stre2 = (_props$validator9 = props.validator) == null ? void 0 : _props$validator9["street-number"]) != null ? _props$validator$stre2 : null
      };
    });
    const autoCompleteLabel = computed(() => {
      return props.showAutoCompleteLabel ? t("global.doorr.addressLookup") : "";
    });
    const {
      canadaProvinceOptions
    } = GLOBAL_APPLICATION_FIELD_OPTIONS;
    const {
      buildCanadianPostalCode
    } = useInputMask();
    const {
      inputMask: postalCodeMask
    } = buildCanadianPostalCode();
    const openManualAddress = open => {
      typeManualAddress.value = open;
    };
    return {
      line1Model,
      line2Model,
      unitNumberModel,
      streetNumberModel,
      streetNameModel,
      streetDirectionModel,
      streetTypeModel,
      provinceModel,
      canadaProvinceOptions,
      cityModel,
      postalCodeModel,
      handleAutocomplete,
      showAddressFields,
      postalCodeMask,
      typeManualAddress,
      validatorFields,
      autoCompleteLabel,
      openManualAddress
    };
  }
});